/**
 * @module router/modules/agent-admin
 * @description AI 에이전트 관리 라우트 모듈 — ADMIN 전용 `/agent-admin` 셸을 제공합니다.
 * meta.roles=['ADMIN'] 으로 roleGuard 가 비-ADMIN 진입을 /dashboard 로 리다이렉트합니다.
 * (agent-admin dev-guide §3 — SURINP-218 report 라우트 선례 복제)
 */

const routes = [
  {
    path: '/agent-admin',
    // stores/menu.js 메뉴명과 일치 — 메뉴 클릭(menuName 전달) / 직접 URL 진입(route.name fallback)
    // 양쪽에서 탭 제목·헤더·브레드크럼이 동일하게 표시되도록 한글 라우트명 사용 (repair.js 선례)
    name: 'AI 에이전트 관리',
    component: () => import(/* webpackChunkName: "agentAdmin" */ '../../views/agent-admin/AgentAdminView.vue'),
    meta: {
      platform: 'web',
      menuYn: true,
      authorization: true,
      roles: ['ADMIN']
    }
  }
]

export default routes
